export interface ClerkSignInProps {
  forceRedirectUrl?: string;
  signUpForceRedirectUrl?: string;
  appearance?: { elements: Record<string, { display: "none" }> };
}

// W-0add48e2: in the Desk, Clerk's Google (and any social) sign-in cannot complete yet, because production Clerk
// only hands the SSO nonce to allowlisted redirects and cleo://app/ is held until nonce binding is proved
// (Orchestrator, 8 Oct 2026). So the Desk hides the social buttons and the "or" divider. socialButtonsRoot also
// covers the social choices on Clerk's "Use another method" screen, which stays reachable: it still lists email
// link, phone and passkey alternatives and "Having trouble? Get help". The browser sign-in keeps social sign-in.
export const DESK_EMAIL_ONLY_APPEARANCE = {
  elements: {
    socialButtonsRoot: { display: "none" },
    dividerRow: { display: "none" },
  },
} as const satisfies NonNullable<ClerkSignInProps["appearance"]>;

export function resolveClerkSignInProps(href: string, isElectron: boolean): ClerkSignInProps {
  if (isElectron) {
    // Electron routes through the hash, so reset any Clerk virtual pathname without losing the Cleo page.
    const redirectUrl = new URL(href);
    redirectUrl.pathname = "/";
    redirectUrl.search = "";

    return {
      forceRedirectUrl: redirectUrl.toString(),
      signUpForceRedirectUrl: redirectUrl.toString(),
      appearance: DESK_EMAIL_ONLY_APPEARANCE,
    };
  }
  return { forceRedirectUrl: href };
}
